import React, { useContext, useEffect } from "react";
import { View, Text, TouchableOpacity, Dimensions, Image } from "react-native";
import { useColorScheme } from "react-native-appearance";
import Icon from "react-native-vector-icons/Ionicons";
import { colors } from "../context/Colors";
import AppContext from "../context";
import GameFooter from "./GameFooter";
import GameDescription from "./GameDescription";
import { isTablet } from "react-native-device-info";

const calcSize = () => {
  const width = window.innerWidth;

  if (width > 700) {
    return width / 3.5 - 27;
  } else {
    return width / 2 - 27;
  }
};

export default function MCQImage({ g, current }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { tour, setTour, resolveURL } = useContext(AppContext);
  const size = calcSize();

  useEffect(() => {
    g.propositions.some((p) => {
      if (p.flag) {
        g.correctImage = p.imageReference;
        return true;
      }
      return false;
    });
    setTour({ ...tour });
  }, []);

  const answer = (k) => {
    //Check is it required to give multiple answers
    if (g.propositions.filter((p) => p.flag).length > 1) {
      g.state = "";
      g.propositions[k].checked
        ? (g.propositions[k].checked = false)
        : (g.propositions[k].checked = true);

      g.propositions.some((p) => {
        if (p.checked) {
          g.state = "can-answer";
          return true;
        }
      });
    } else {
      g.propositions.forEach((p) => {
        delete p.checked;
      });
      g.propositions[k].checked = true;
      g.state = "can-answer";
    }
    setTour({ ...tour });
  };

  const checkColor = (a) => {
    if (g.state === "failed" && a.checked) return "#DD4D4D";
    if (g.state === "correct" && a.checked) return "#26C97A";
    if (a.checked) return "#23A7F1";
    return colors[theme].gameButtonBg;
  };

  const overlayColor = (a) => {
    if (g.state === "failed" && a.checked) return "#DD4D4D";
    if (g.state === "correct" && a.checked) return "#26C97A";
    if (a.checked) return "#23A7F1";
    return "transparent";
  };

  const insertFakeBoxes = () => {
    const fakes = new Array(3 - (g.propositions.length % 3));
    if (isTablet())
      return (
        <>
          {fakes.fill(null).map((f, k) => (
            <View key={k} style={{ width: size - 10 + 20 }} />
          ))}
        </>
      );
    return null;
  };

  return (
    <View>
      <GameDescription g={g} current={current} />
      <View
        style={{
          marginTop: 10,
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignSelf: "center",
        }}
      >
        {g.propositions.map((a, k) => (
          <TouchableOpacity
            key={a.propositionID}
            style={{
              marginTop: 20,
              flexDirection: "row",
              alignItems: "center",
              marginHorizontal: isTablet() ? 10 : 5,
            }}
            onPress={() => answer(k)}
            disabled={g.state === "failed" || g.state === "correct"}
            activeOpacity={0.8}
          >
            <View
              style={{
                backgroundColor: checkColor(a),
                borderRadius: 8,
                justifyContent: "center",
                alignItems: "center",
                shadowColor: "#000",
                shadowOffset: {
                  width: 0,
                  height: 1,
                },
                shadowOpacity: 0.15,
                shadowRadius: 3.84,
                elevation: 5,
              }}
            >
              <Image
                source={{
                  uri: resolveURL("game", a.imageReference, 300),
                }}
                style={{
                  width: size - 10,
                  height: size - 10,
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                }}
                resizeMode={"contain"}
              />
              <View
                style={{
                  position: "absolute",
                  width: size,
                  height: size,
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                  top: 0,
                  left: 0,
                  backgroundColor: overlayColor(a),
                  opacity: 0.4,
                }}
              />
              {a.checked && (g.state === "correct" || g.state === "failed") ? (
                <View
                  style={{
                    backgroundColor: "#FFF",
                    width: 24,
                    height: 24,
                    marginRight: 8,
                    borderRadius: 12,
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    top: 10,
                    left: 10,
                  }}
                >
                  <Icon
                    name="md-checkmark-sharp"
                    size={18}
                    color={checkColor(a)}
                  />
                </View>
              ) : null}

              <Text
                style={{
                  fontSize: 15,
                  opacity: a.checked ? 1 : 0.5,
                  color: a.checked ? "#FFF" : colors[theme].text,
                  marginVertical: 12,
                }}
              >
                {a.text}
              </Text>
            </View>
          </TouchableOpacity>
        ))}
        {insertFakeBoxes()}
      </View>

      <GameFooter g={g} size={size} />
      <View style={{ height: 60 }} />
    </View>
  );
}
